import { ReactComponent as IconSvg } from 'approot/shared/inline-svg/activity-builder/icon_font_type.svg';
import Icon, { IconProps } from '../../icons/icon';

const IconFontType = (props: IconProps) => {
  return <Icon {...props} Svg={IconSvg} />;
};

export default IconFontType;
